import { useCallback } from 'react'

import type { FanOriginDto } from '@api'
import { useUnit } from 'effector-react'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'
import { removeFanCategoryFx } from '@/dialogs/EditFanOriginDialog/models.ts'

import type { DialogProps } from '../types'

interface Props extends DialogProps {
  origin: FanOriginDto
}

export const DeleteFanOriginDialog = ({ isOpen, onClose, origin }: Props) => {
  const isRemoving = useUnit(removeFanCategoryFx.pending)
  const { id, name } = origin
  const onSubmit = useCallback(async () => {
    await removeFanCategoryFx(id)
    onClose()
  }, [id, onClose])

  return (
    <Dialog
      bigDialog
      childrenClassName="space-y-6"
      panelClassName="lg:max-w-[533px]"
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>Delete origin</Dialog.Title>
      </Dialog.Header>

      <p className="text-sm">
        Are you sure you want to delete <b>{name}</b> category? This cannot be
        undone.
      </p>

      <Dialog.ClosableFooter
        onClose={onClose}
        disabled={isRemoving}
      >
        <Button
          variant="destructive"
          onClick={onSubmit}
          isLoading={isRemoving}
        >
          Delete
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
